<template>
  <div class="container-fluid"> 
        
    <div class="container mt-5">
      <div class="row filter-block justify-content-center">
        <div class="col-12 col-md-4">
          <p>{{$t('planes_buscar')}}</p>
        </div>
        <div class="col-12 col-md-8">
          <BuscadorMenuPlanes :dataset="dataset"></BuscadorMenuPlanes>
        </div>
      </div>     

      <div class="row filter-block mt-5 mb-5">
        <div class="col-12 col-md-12 year-block">
          <b-tabs class="text-center"  content-class="mt-3">
            <b-tab :title="$t('filtrar por')" active>
              <b-tab :title="$t('planes_anio_sup')">      
              <b-form-group>
                <template #label>
                  <b-form-checkbox
                    class="check"
                    aria-describedby="anio_supervicion"
                    aria-controls="anio_supervicion"
                    @change="toggleAll"
                  >
                    {{ yearSelected.length > 0 ? $t('planes_options_select_anio') : $t('planes_options_select_todos')}}
                  </b-form-checkbox>
                </template>

                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group  v-model="yearSelected" :options="yearInforme" :aria-describedby="ariaDescribedby"
                    name="anio_supervicion"
                    class="ml-4 check"
                  ></b-form-checkbox-group>               
                </template>
              </b-form-group>
              </b-tab>
              <b-tab :title="$t('planes_anio_aprob')">  
              <b-form-group>
                <template #label>
                  <b-form-checkbox
                    class="check"
                    aria-describedby="anio_aprob"
                    aria-controls="anio_aprob"
                    @change="toggleAprob"
                  >
                    {{ anio_aprob_selected.length > 0 ? $t('planes_options_select_anio') : $t('planes_options_select_todos') }}
                  </b-form-checkbox>
                </template>

                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group  v-model="anio_aprob_selected" :options="yearAprobacion" :aria-describedby="ariaDescribedby"
                    name="anio_aprob"
                    class="ml-4 check"
                  ></b-form-checkbox-group>               
                </template>
              </b-form-group>

              </b-tab>
              <b-tab :title="$t('planes_modalidad')">  

              <b-form-group>
                <template #label>
                  <b-form-checkbox
                    class="check"
                    aria-describedby="modalidad_selected"
                    aria-controls="modalidad_selected"
                    @change="toggleModalidad"
                  >
                    {{ modalidad_selected.length > 0 ? $t('planes_options_select_modality') : $t('planes_options_select_todos_modality') }}
                  </b-form-checkbox>
                </template>

                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group  v-model="modalidad_selected" :options="modalidad" :aria-describedby="ariaDescribedby"
                    name="modalidad_selected"
                    class="ml-4 check"
                  ></b-form-checkbox-group>               
                </template>
              </b-form-group>

              
              </b-tab>
              <b-tab :title="$t('plan_region')">

              <b-form-group>
                <template #label>
                  <b-form-checkbox
                    class="check"
                    aria-describedby="departamento_selected"
                    aria-controls="departamento_selected"
                    @change="toggleDep"
                  >
                    {{ anio_aprob_selected.length > 0 ? $t('plan_region_select') : $t('plan_region_select_all') }}
                  </b-form-checkbox>
                </template>

                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group  v-model="departamento_selected" :options="departamentos" :aria-describedby="ariaDescribedby"
                    name="departamento_selected"
                    class="ml-4 check"
                  ></b-form-checkbox-group>               
                </template>
              </b-form-group>
              </b-tab>
            </b-tab>
            
            <b-tab :title="$t('plan_region_lista')" active>
              <div>
                <div class="row mt-5 mb-5">
                  <div class="col-12 col-md-12 planes-results">            
                      <b-tabs pills vertical >
                        <b-tab :key="year+'-group'" v-for="(planes, year) in byDepartamento" :title="year">
                          <template #title>
                            {{ year}} ({{ planes.length }})
                          </template>
                         <div class="row border-bottom regente-plan-item pt-3 pb-3" :key="id" v-for="(plan, id) in planes">
                            <div class="col-12 col-md-5">
                              <label class="label-planes"> {{$t('planes_titular')}}</label>
                              <h5> {{plan.titular_actual}} </h5>
                              <label class="label-planes"> {{$t('planes_numero_th')}}</label>
                              <h5> {{plan.numero_th}}</h5>
                              <label class="label-planes">{{$t('planes_modalidad')}}</label>
                              <h5> {{$t(plan.modalidad)}}</h5>
                              
                            </div>
          
                            <div class="col-12 col-md-3">
                                <label class="label-planes">{{$t('planes_resolucion')}}</label>
                                <h5>{{plan.resolucion_poa}}</h5>
                                <label class="label-planes">{{$t('planes_fecha_aprob')}}</label>
                                <h5>{{plan.date_aprob_raw}}</h5>
                                <label class="label-planes">{{$t('planes_fecha_sup')}}</label>
                                <h5>{{plan.fecha_sup_raw}}</h5>                      
                            </div>
          
                            <div class="col-12 col-md-2">                              
                              <label class="label-planes">{{$t('planes_distri_prov')}}</label>
                              <h5> {{plan.distrito}} /{{plan.provincia}} </h5>
                            </div>
          
                            <div class="col-12 col-md-2 align-self-center">

                              <router-link  :to="{ name: 'PlanPageDetalles' , params:{ id: plan.resolucion_poa_id}}"
                               class="btn"> {{$t('planes_ver_pmf')}}</router-link>
                            </div>
          
                          </div>                  
                        </b-tab>
                      </b-tabs>
                  </div>
          
                </div>
                
              </div>
            </b-tab>
            
          </b-tabs>
          
        </div>
        
        
      </div>

    </div>
    
    
 
  </div>
</template>

<script>


import BuscadorMenuPlanes from '../components/BuscadorMenuPlanes.vue'
import { groupBy, map, uniq, filter } from "lodash"

export default {
  name: 'Planessaep',
  props: {
     dataset: Array
  },
  components: {
    BuscadorMenuPlanes
  },
  data() {
    return {
      yearSelected: [2010],
      modalidad_selected: ['concesión_forestal_maderable'],
      anio_aprob_selected: ["2005"],
      departamento_selected: ['LORETO'],
      filterActive: 0
    }
  },
  methods: {
    toggleAll(checked) {
      this.yearSelected = checked ? this.yearInforme.slice() : []
    },
    toggleAprob(checked) {
      this.anio_aprob_selected = checked ? this.yearAprobacion.slice() : []
    },
    toggleModalidad(checked) {
      this.modalidad_selected = checked ? map(this.modalidad, 'value').slice() : []
    },
    toggleDep(checked) {
      this.departamento_selected = checked ? this.departamentos.slice() : []
    }    
  },
  computed:{    
    filterData() {
      if(this.filterActive === 0) {
        return filter(this.dataset, item => (this.yearSelected.includes(item.anio) && this.modalidad_selected.includes(item.modalidad) && this.departamento_selected.includes(item.departamento)))
      } else if(this.filterActive === 1) {
        return filter(this.dataset, item => (this.anio_aprob_selected.includes(item.anio_aprob) && this.modalidad_selected.includes(item.modalidad) && this.departamento_selected.includes(item.departamento)))
      }
      return false
    },
    byDepartamento() {
      console.log(this.filterData)
      return groupBy(this.filterData, "departamento")
    },
    yearInforme() {
      let subset = map(this.dataset, "anio").sort()
      return uniq(subset)          
    },
    yearAprobacion() {
      let subset = map(this.dataset, "anio_aprob").sort()
      return uniq(subset)          
    },
    modalidad() {
      let subset=map(this.dataset, 'modalidad').sort()

      return map(uniq(subset), m => {
        return {
          text: this.$t(m),
          value: m
        }
      })
    },
    departamentos() {
      return uniq(map(filter(this.dataset, item => this.yearSelected.includes(item.anio) && this.modalidad_selected.includes(item.modalidad)), "departamento").sort())          
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
